import React from 'react';
import PropertyDevelopersTable from 'src/components/PropertyDevelopersTable/PropertyDevelopersTable';
import { PropertiesForContactsProvider } from 'src/pages/Contacts/ContactsContext/PropertiesForContactsContext';
import { ContactFormProvider } from 'src/SharedCommonContext/ContactFormContext';
import {
  usePropertyDevelopersPageOrchestrator,
  UsePropertyDevelopersPageOrchestratorReturn,
} from 'src/pages/Property/PropertyDevelopers/CustomHooks/usePropertyDevelopersPageOrchestrator';

const PropertyDevelopersContent = ({ property }: any) => {
  const orchestrator: UsePropertyDevelopersPageOrchestratorReturn =
    usePropertyDevelopersPageOrchestrator(property);

  return <PropertyDevelopersTable {...orchestrator} />;
};

const PropertyDevelopers = ({ property }: any) => {
  return (
    <ContactFormProvider>
      <PropertiesForContactsProvider>
        <PropertyDevelopersContent property={property} />
      </PropertiesForContactsProvider>
    </ContactFormProvider>
  );
};

export default PropertyDevelopers;
